import { useEffect } from "react";
import { useNavigate } from "react-router";
import { trackEvent } from "@viajero/shared-ui/analytics";
import { ReservationCompleteStep } from "@/features/reservation/components/ReservationCompleteStep";
import { clearBookingDraft, hasCheckoutStarted } from "@/lib/bookingDraftStorage";
import { loadLastShopLocation } from "@/lib/lastShopLocation";

/**
 * 予約完了画面 (/reservations/:reservationToken/complete)。決済成功後の success_url (§7.1)。
 * 予約アクセストークンは ReservationTokenLayout が interceptor へ渡すため、本画面はパラメータを
 * 受け取らず GetReservation のポーリングで確定を待つ (§3.1)。
 *
 * success_url は caseToken / shopId を含まないため、購入者情報画面が Stripe へ出る直前に
 * sessionStorage へ退避した戻り先を読み出す (JPTP_CANSEI-1522)。メール流入・別タブでは
 * 退避が無く、その場合は戻る導線を渡さない (メール導線の案内へフォールバックする)。
 */
export default function ReservationCompletePage() {
  const navigate = useNavigate();
  const lastShop = loadLastShopLocation();

  // 決済を終えた時点で予約内容の下書きを捨てる (JPTP_CANSEI-1428)。残したままだと確定済み
  // 予約の reservationId が復元され、コース画面へ戻ったときの「決済に進む」が必ず失敗する。
  //
  // 併せて Stripe の決済画面から本画面へ戻ってきたことを計測する (JPTP_CANSEI-1656)。
  // Stripe 画面内の操作は別ドメインのため検知できず、戻ってきた時点が計測できる唯一の点。
  // 決済へ出た印が残っているときだけ送るため、リロード・別タブでの再訪では送らない
  // (印ごと下書きを直後に捨てるので、StrictMode の二重実行でも 1 回に収まる)。
  useEffect(() => {
    if (hasCheckoutStarted()) {
      trackEvent("payment_complete");
    }
    clearBookingDraft();
  }, []);

  return (
    <ReservationCompleteStep
      onBackToShop={
        lastShop ? () => navigate(`/${lastShop.caseToken}/${lastShop.shopId}`) : undefined
      }
    />
  );
}
